import React from 'react';

type ReplyIconProps = {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  className?: string;
};

export function ReplyIcon({ onClick, className = '' }: ReplyIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        d="M19 9.5C19 9.5 15.5811 13 10 13C4.41886 13 1 9.5 1 9.5M1 9.5V3M1 9.5L6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ReplyIcon;
